import React from 'react';

export default function RegistryToolbar({
  search,
  setSearch,
  onSearch,
  onCreate,
  createLabel = 'Create New',
  placeholder = 'Search here',
}) {
  return (
    <div className="mb-4 flex items-center gap-3">
      <div className="relative flex-1">
        <svg
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          onKeyDown={(event) => event.key === 'Enter' && onSearch()}
          placeholder={placeholder}
          className="w-full rounded-lg border border-gray-200 py-2.5 pl-9 pr-4 text-sm text-gray-700 placeholder-gray-400 focus:border-green-400 focus:outline-none focus:ring-1 focus:ring-green-400"
        />
      </div>
      <button
        type="button"
        onClick={onSearch}
        className="rounded-lg border border-green-200 bg-green-50 px-5 py-2.5 text-sm font-semibold text-green-700 hover:bg-green-100"
      >
        Search
      </button>
      <button
        type="button"
        onClick={onCreate}
        className="flex items-center gap-1.5 rounded-lg bg-green-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-green-800"
      >
        <span className="text-base font-bold leading-none">+</span> {createLabel}
      </button>
    </div>
  );
}
